// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"82d74160","867":"0e96b26d"}[chunkId] + ".chunk.js";
};